import StoreSettingsPage from './detail/StoreSettingsPage';
import EmailTabs from './detail/EmailTabs';

export default function StoreEmail() {
	return (
		<StoreSettingsPage title='Store - Email'>
			{(store) => <EmailTabs storeId={store.storeId} />}
		</StoreSettingsPage>
	);
}
